import { useState, useEffect } from 'react';

export default function SolutionsClosing() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    industry: '',
    challenge: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitAddr, setSubmitAddr] = useState('');

  useEffect(() => {
    fetch('https://readdy.ai/api/form/url', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: 'AI Systems Audit Request' })
    })
      .then(res => res.json())
      .then(data => setSubmitAddr(data.url))
      .catch(err => console.error('Form URL fetch error:', err));
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (formData.challenge.length > 500) {
      alert('Challenge description must be 500 characters or less');
      return;
    }

    setIsSubmitting(true);

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString()
      });

      setSubmitSuccess(true);
      setFormData({ name: '', email: '', company: '', industry: '', challenge: '' });
      
      setTimeout(() => setSubmitSuccess(false), 5000);
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section className="bg-white py-32 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-light tracking-tight text-gray-900 mb-6">
            Automation Built for Real Operations
          </h2>
          <p className="text-xl font-light text-gray-600 leading-relaxed">
            Sapentis AI systems are designed for operational environments where reliability and accountability matter.
          </p>
        </div>

        <div className="bg-white border border-gray-200 rounded-3xl p-12 shadow-sm">
          <h3 className="text-2xl font-medium text-gray-900 mb-8 text-center">
            Request an AI Systems Audit
          </h3>

          <form id="ai-systems-audit-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-6 py-4 bg-gray-50 border border-gray-200 rounded-xl text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent transition-all whitespace-nowrap"
              />
            </div>

            <div>
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-6 py-4 bg-gray-50 border border-gray-200 rounded-xl text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent transition-all whitespace-nowrap"
              />
            </div>

            <div>
              <input
                type="text"
                name="company"
                placeholder="Company Name"
                value={formData.company}
                onChange={handleChange}
                required
                className="w-full px-6 py-4 bg-gray-50 border border-gray-200 rounded-xl text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent transition-all whitespace-nowrap"
              />
            </div>

            <div>
              <select
                name="industry"
                value={formData.industry}
                onChange={handleChange}
                required
                className="w-full px-6 py-4 bg-gray-50 border border-gray-200 rounded-xl text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent transition-all cursor-pointer whitespace-nowrap"
              >
                <option value="">Select Industry</option>
                <option value="Law Firms">Law Firms</option>
                <option value="CPA / Accounting">CPA / Accounting</option>
                <option value="Medspas">Medspas & Aesthetic Clinics</option>
                <option value="Mental Health">Mental Health Practices</option>
                <option value="Home Services">Home Services</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div>
              <textarea
                name="challenge"
                placeholder="Describe your operational challenge (max 500 characters)"
                value={formData.challenge}
                onChange={handleChange}
                maxLength={500}
                rows={4}
                required
                className="w-full px-6 py-4 bg-gray-50 border border-gray-200 rounded-xl text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent transition-all resize-none"
              />
              <p className="text-sm text-gray-500 mt-2 text-right">
                {formData.challenge.length}/500
              </p>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-gray-900 text-white py-4 px-8 rounded-full text-base font-medium hover:bg-gray-800 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {isSubmitting ? 'Submitting...' : 'Request Audit'}
            </button>

            {submitSuccess && (
              <div className="bg-green-50 border border-green-200 text-green-800 px-6 py-4 rounded-xl text-center">
                Thank you! We'll be in touch soon.
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
